module.exports = __webpack_public_path__ + "static/media/25UNHCR4.2c2a66f4.jpg";